import React from 'react';
import { Link } from 'react-router-dom';
import { getPopularLocations } from '../../data/bhubaneswarLocations';
import './Footer.css';

const Footer = () => {
  const popularLocations = getPopularLocations().slice(0, 12);
  const currentYear = new Date().getFullYear();

  return (
    <footer className="oz-footer">
      <div className="oz-footer-container">
        {/* Main Footer Content */}
        <div className="oz-footer-grid">
          {/* Brand Section */}
          <div className="oz-footer-brand">
            <Link to="/" className="oz-footer-logo">
              <span className="oz-footer-logo-icon">🍛</span>
              <div className="oz-footer-logo-text">
                <span className="oz-footer-logo-name">Odisha Zaika</span>
                <span className="oz-footer-logo-tagline">Authentic Odia Flavors</span>
              </div>
            </Link>
            <p className="oz-footer-description">
              Experience the rich culinary heritage of Odisha with our authentic dishes.
              From traditional thalis to modern favorites, we bring the best of Odia cuisine to your doorstep.
            </p>
            <div className="oz-footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="oz-social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="oz-social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="18" cy="6" r="1"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="oz-social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
                </svg>
              </a>
              <a href="https://wa.me/917873611363" target="_blank" rel="noopener noreferrer" className="oz-social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="oz-footer-section">
            <h4 className="oz-footer-heading">Quick Links</h4>
            <ul className="oz-footer-links">
              <li><Link to="/menu">Full Menu</Link></li>
              <li><Link to="/offers">Offers & Deals</Link></li>
              <li><Link to="/track-order">Track Order</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div className="oz-footer-section">
            <h4 className="oz-footer-heading">Food Categories</h4>
            <ul className="oz-footer-links">
              <li><Link to="/menu?category=starter">Starters</Link></li>
              <li><Link to="/menu?category=thali">Odia Thali</Link></li>
              <li><Link to="/menu?category=biryani">Biryani</Link></li>
              <li><Link to="/menu?category=curries">Curries</Link></li>
              <li><Link to="/menu?category=noodles">Noodles & Rice</Link></li>
              <li><Link to="/menu?category=desserts">Desserts</Link></li>
            </ul>
          </div>

          {/* Delivery Locations */}
          <div className="oz-footer-section">
            <h4 className="oz-footer-heading">Delivery Areas</h4>
            <ul className="oz-footer-links oz-footer-locations">
              {popularLocations.slice(0, 8).map(location => (
                <li key={location.slug}>
                  <Link to={`/location/${location.slug}`}>{location.name}</Link>
                </li>
              ))}
              <li><Link to="/locations" className="oz-view-all">View All Locations</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="oz-footer-section">
            <h4 className="oz-footer-heading">Contact Us</h4>
            <div className="oz-footer-contact">
              <div className="oz-contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Bhubaneswar, Odisha, India</span>
              </div>
              <div className="oz-contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <a href="tel:+917873611363">+91 78736 11363</a>
              </div>
              <div className="oz-contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <a href="mailto:hello@odishazaika.com">hello@odishazaika.com</a>
              </div>
              <div className="oz-contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                <span>Open: 10 AM - 10 PM</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="oz-footer-bottom">
          <div className="oz-footer-bottom-content">
            <p className="oz-copyright">
              &copy; {currentYear} Odisha Zaika. All rights reserved.
            </p>
            <div className="oz-footer-legal">
              <Link to="/terms">Terms of Service</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/refund">Refund Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
